// Module
var code = "<ng-transclude class=\"choice-interaction\"></ng-transclude>";
// Exports
module.exports = code;